import { c as _c } from "react/compiler-runtime";
import { forwardRef } from "react";

/**
 * @typedef {Omit<import("react").ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> & {
 *   label: string,
 *   variant?: "default" | "subtle" | "map"
 * }} IconButtonProps
 */

const VARIANT_CLASSES = {
  default: "hover:bg-zinc-100 active:bg-zinc-100 dark:bg-black dark:hover:bg-zinc-800 dark:active:bg-zinc-800",
  subtle: "hover:bg-zinc-400/10 active:bg-zinc-400/10",
  map: "bg-white shadow-md hover:bg-zinc-100 active:bg-zinc-100 dark:bg-black dark:hover:bg-zinc-800 dark:active:bg-zinc-800"
};
const IconButton = forwardRef(
/**
 * @param {IconButtonProps} props
 * @param {import("react").ForwardedRef<HTMLButtonElement>} ref
 */
function IconButton(t0, ref) {
  const $ = _c(16);
  let children;
  let label;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      children,
      className: t1,
      disabled: t2,
      label,
      type: t3,
      variant: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = label;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    children = $[1];
    label = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const className = t1 === undefined ? "" : t1;
  const disabled = t2 === undefined ? false : t2;
  const type = t3 === undefined ? "button" : t3;
  const variant = t4 === undefined ? "default" : t4;
  const variantClassName = VARIANT_CLASSES[variant] || VARIANT_CLASSES.default;
  const t5 = `pointer-events-auto grid h-9 w-9 flex-shrink-0 place-items-center rounded-full outline-none ring-blue-500/50 transition-colors duration-150 motion-reduce:transition-none focus-visible:ring disabled:pointer-events-none disabled:opacity-50 ${variantClassName} ${className}`;
  let t6;
  if ($[8] !== children || $[9] !== disabled || $[10] !== label || $[11] !== props || $[12] !== ref || $[13] !== t5 || $[14] !== type) {
    t6 = <button {...props} ref={ref} type={type} disabled={disabled} aria-label={label} className={t5}>{children}</button>;
    $[8] = children;
    $[9] = disabled;
    $[10] = label;
    $[11] = props;
    $[12] = ref;
    $[13] = t5;
    $[14] = type;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});
export default IconButton;